module.exports = __webpack_public_path__ + "img/pdf-icon-colored.ef85769e.svg";